import React from "react";

const useFileUpload = () => {
    const readFileDataAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                resolve(event.target.result);
            };

            reader.onerror = (err) => {
                reject(err);
            };

            reader.readAsDataURL(file);
        });
    }

    return {
        readFileDataAsBase64
    }
}

export default useFileUpload;